import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/login.css';
import useSignup from '../hooks/useSignup';

function SuperAdminReg() {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error2, setError2] = useState(''); // Error state
  const BASE_URL = process.env.REACT_APP_BASE_URL; 
  const navigate = useNavigate()
  const {signup, error, isLoading} = useSignup()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError2(''); 
    

    if (password !== password2) {
      setError2('Passwords do not match');
      return;
    }

    

    await signup(username, fullName, email, password, password2);
    if(!error)
    {
      navigate('/login')
      console.log("Successfully registered!!")
    }else{
      console.log(error)
    }
    
  };

  return (
    <div className='login'>
      <div>
        <h1>Immuniso</h1>
        <h3>Super Admin Register</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <label htmlFor="username"><b>Username</b></label>
        <input 
          type="text" 
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
          required 
        />

        <label htmlFor="fullName"><b>Full Name</b></label>
        <input 
          type="text" 
          value={fullName} 
          onChange={(e) => setFullName(e.target.value)} 
          required 
        />

        <label htmlFor="email"><b>Email</b></label>
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          required 
        />

        <label htmlFor="password"><b>Password</b></label>
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          required 
        />
        
        <label htmlFor="password2"><b>Confirm Password</b></label>
        <input 
          type="password" 
          value={password2} 
          onChange={(e) => setPassword2(e.target.value)} 
          required 
        />

        {/* Display error message if any */}
        {error && <p className='error-message'>{error}</p>}

        <button className='lrBtn' type="submit">Register</button>
      </form>
    </div>
  );
}

export default SuperAdminReg;
